<template>
	<div class="heads">
		<div class="big-center">
			<div class="center">
				<el-row :gutter="20">
					<el-col :span="10">
						<div class="top-left">
							<div class="logoname">{{ $t('navbar.welcomes') }}{{ $t('navbar.companyName') }}</div>
							<div class="logins">
								<span v-if="!userId" @click="goAbute('/login')">{{ $t('navbar.login') }}</span>
								<span v-if="!userId" class="xian">|</span>
								<span v-if="!userId" @click="goAbute('/login?navgatorIndex=3')">{{ $t('navbar.registration') }}</span>
								<span v-if="userId" @click="quit()">{{ $t('navbar.quit') }}</span>
							</div>
						</div>
					</el-col>
					<!-- <el-col :span="5"><div class="kong"></div></el-col> -->
					<el-col :span="14">
						<div class="top-right">
							<span @click="goAbute('/?index=0')">{{ $t('navbar.homePage') }}</span>
							<span @click="goShoppingCar('/order')">{{ $t('navbar.personal') }}</span>
							<span>
								<span @click="goChat()" class="el-dropdown-link" style="color: #999;">
									{{ $t('navbar.contactService') }}
								</span>
							</span>
						<!-- 	<span >
								<el-dropdown  @command="handleCommand">
									<span class="el-dropdown-link" style="color: #999;">
										网站导航<i class="el-icon-arrow-down el-icon--right"></i>
									</span>
									<el-dropdown-menu slot="dropdown">
										<div style="width: 200px;display: inline-block;">
											<el-dropdown-item v-for="(item,index) in list" :key="index" :command="item.url" >{{item.name}}</el-dropdown-item>
										</div>
									</el-dropdown-menu>
								</el-dropdown>
							</span> -->
							<span >
								<el-dropdown>
									<span class="el-dropdown-link" style="color: #999;">
										{{ $t('navbar.mobile') }}<i class="el-icon-arrow-down el-icon--right"></i>
									</span>
									<el-dropdown-menu slot="dropdown">
										<el-dropdown-item>
											<img style="height: 100px;width: 100px;" :src="downcode" />
										</el-dropdown-item>
									</el-dropdown-menu>
								</el-dropdown>
							</span>
							<span>
								<Lang class="right-menu-item"></Lang>
							</span>
						</div>
					</el-col>
				</el-row>
			</div>
		</div>
		<div class="big-centers">
			<div class="center">
				<div class="cons left" @click="goHome()" >
					<img src="../assets/head/logo.png" />
				</div>
				<div class="cons cont">
					<div class="searchs" >
						<el-input :placeholder="$t('navbar.contentSearch')" v-model="value" class="input-with-select">
							<el-button slot="append" icon="el-icon-search"  @click="goAbute('/productList?title=' + value)">{{ $t('navbar.search') }}</el-button><!-- @click="sousuo()" -->
						</el-input>
					</div>
					<div class="search-list">
						<div v-for="(item,index) in data" :key="index" :class="index<=2?'one':'four'"
							 @click="goAbute('/productList?title=' + item)">
							<span v-if="index==0" class="re bao">HOT</span>
							<span v-if="index==1||index==2" class="re">HOT</span>
							{{item}}
						</div>
					</div>
				</div>
				<div class="cons right">
					<div class="myCars">
						<el-badge v-if="dataC" :value="dataC.length" class="item">
							<img class="carimg" src="../assets/head/card.png" />
							<span class="myCar" @click="goShoppingCar('/shoppingCar')">{{ $t('navbar.myCart') }}</span>
						</el-badge>
						<div v-else>
							<img class="carimg" src="../assets/head/card.png" />
							<span class="myCar" @click="goShoppingCar('/shoppingCar')">{{ $t('navbar.myCart') }}</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Head',
	props: {
		data: [],
		dataC:[]
	},
	data () {
		return {
			value: '',
			// userId:'',
			list:[
				{ name:'热卖榜单', url:'/?index=1' },
				{ name:'精选好物', url:'/?index=2' },
				{ name:'每日上线', url:'/?index=3' },
				{ name:'拼团购', url:'/?index=4' },
				// { name:'个人中心', url:'/order' },
			],
			downcode:'../assets/foot/app.png',
			version:'en',
		}
	},
	mounted() {
		// console.log(this.$cookie.get('userId'))
		// this.userId = this.$cookie.get('userId')
		if(!this.$cookie.get('language')){
			this.$i18n.locale = 'en'
			this.$cookie.set('language', 'en')
		}
		this.getCode()
		var version = this.version
		setInterval(() => {
			version = this.$cookie.get('language')
			if(version!=this.version){
				this.version = version
				this.getCode()
			}
		}, 1000)
	},
	created() {
		this.getCode()
		
	},
	computed: {
		userId() {
			// return this.$store.state.userId
			return this.$cookie.get('userId')
		},
		
	},
	methods:{
		goShoppingCar(url) {
			if(this.userId) {
				this.$router.push({
					path: url
				})
			} else {
				this.$router.push({
					path: '/login'
				})
			}

		},
		goHome() {
			if(this.$route.path == '/') {

			} else {
				this.$router.push({
					path: '/'
				})
			}

		},
		goAbute(url){
			this.$router.push({
				path: url
			})
		},
		goChat() {
			if(this.userId) {
				this.$http({
					url: this.$http.adornUrl('/chat/save'),
					method: 'post',
					data: this.$http.adornData({
						storeHead: "地摊兄自营店铺",
						storeId: "0",
						storeName: "",
						userId: this.$cookie.get('userId'),
						userName: this.$cookie.get('nickName'),
					})
				}).then(({data}) => {
					let returnData = data.data;
					this.$router.push({
						path: '/vueMchat?chatId='+ returnData.chatId
					})
				})
			} else {
				this.$router.push({
					path: '/login'
				})
			}
		},
		handleCommand(command) {
			this.$router.push({
				path: command
			})
		},
		sousuo(){
			if(this.value==''){
				// this.$message('搜索内容不能为空')
			}
		},
		//退出登录
		quit() {
			this.$store.commit('updateUserId','')
			this.$store.commit('updateRelationId','')

			this.$cookie.set('uuid','')
			this.$cookie.set('userId','')
			this.$cookie.set('relationId', '')
			this.$cookie.set('image_url', '')
			this.$cookie.set('nickName', '')
			this.$cookie.set('phone', '')
			console.log(this.$route.path,'当前页路由')
			if(this.$route.path == '/') {
				this.$router.go(0)
			} else {
				this.$router.push({
					path: '/'
				})
			}

		},
		getCode() {
			if(this.version=='en'){
				this.$http({
					url: this.$http.adornUrl('/common/type/413'), //小程序二维码
					method: 'get',
				}).then(({data}) => {
					if(data.data){
						window.localStorage.setItem("downcode",data.data.value);
						this.downcode = data.data.value
					}
					
				})
			}else{
				this.$http({
					url: this.$http.adornUrl('/common/type/286'), //小程序二维码
					method: 'get',
				}).then(({data}) => {
					if(data.data){
						window.localStorage.setItem("downcode",data.data.value);
						this.downcode = data.data.value
					}
					
				})
			}
			
			
		}

	}
}
</script>
<style scoped="scoped">
.big-center{
	width: 100%;
	height: 24px;
	line-height: 24px;
	color: #999;
	font-size: 14px;
	background: #E6E6E6;
}
.center{
	width: 1200px;
	margin: 0 auto;
}
.top-left{
	text-align: left;

}
.top-left div{
	display: inline-block;
}
.logoname{
	width: 40%;
}
.logins{
	width: 50%;
	text-align: center;
}
.logins span{
	color: #999;
	text-decoration:none;
}
.logins span:hover{
	color: #287EFF;
	cursor: pointer;
}
.xian{
	margin: 0 10px;
}
.kong{
	width: 100%;
	height: 24px;
}
.top-right{
	text-align: right;
}
.top-right span{
	display: inline-block;
	margin-left: 20px;
	color: #999;
	text-decoration:none;
}
.top-right span:hover{
	color: #287EFF;
	cursor: pointer;
}
.big-centers{
	width: 100%;
	height: 120px;
	/* line-height: 120px; */
}
.big-centers .center .cons{
	display: inline-block;
}
.left{
	width: 30%;
	text-align: left;
}
.left img{
	position: relative;
	bottom: 6px;
}

.cont{
	width: 49%;

}
.searchs{
	padding-top: 26px;
}

.search-list{
	text-align: left;
	font-size: 14px;
	color: #999;
	margin-top: 10px;
}
.search-list div{
	display: inline-block;
	width: 16%;
	cursor: pointer;
}
.one{
	color: #287EFF;
}
.one .re{
	display: inline-block;
	font-size: 12px;
	color: #FF1D48;
	border: 1px solid #FF1D48;
	/* width: 14px;
    height: 14px; */
	border-radius: 2px;
	padding: 0 2px;
	/* margin-right: 6px; */
}

.right{
	width: 20%;
	text-align: right;
	color: #FF1D48;
	font-size: 18px;
}
.myCars{
	position: relative;
	bottom: 20px;
	color: #287EFF;
	border: 2px solid #287EFF;
	border-radius: 4px;
	width: 65%;
	text-align: center;
	height: 45px;
	line-height: 45px;
	margin-left: 35%;
	cursor: pointer;
}
.carimg{
	position: relative;
	top: 3px;
}

.el-input-group__append, .el-input-group__prepend{
	background: #287EFF!important;
	color: #fff!important;
	border: 1px solid #287EFF!important;
}
</style>



// WEBPACK FOOTER //
// src/components/head.vue